import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';

<template><Spinner /></template>
